import React, { Component } from 'react';
import Context from './Context'

class Popup extends Component {
  static contextType = Context

  render() {
    return (
      <div
        className="Popup"
        style={{ maxWidth: 200, border: '1px solid rgba(255, 255, 255, 0.2)' }}
      >
        <header
          style={{
            background: this.context.theme === 'dark' ? '#491B9B' : 'cyan',
            fontSize: 16,
            padding: '5px 10px',
            color: this.context.theme === 'dark' ? '#fff' : '#000'
          }}
        >
          { this.props.title }
        </header>
        <div style={{ padding: 15, background: '#fff' }}>
          { this.props.text }
        </div>
      </div>
    );
  }
}

export default Popup;
